var AlligatorView, EmailFormBaseView, EmailFormCheckboxInputView, EmailFormDropdownInputView, EmailFormFileInputView, EmailFormNumberInputView, EmailFormPhoneNumberInputView, EmailFormRecaptchaView, EmailFormTextLineInputView, EmailFormTextParagraphInputView, EmailFormTextParagraphView, EmailFormUSEmailDescriptionView, EmailFormUSMainView, EmailFormUSMerchantLocationInfoView, EmailFormUSUserContactInfoView, EmailFormUSUserIdentificationView, EmailFormUsDateTimeInputView, SupportStepThreeTemplate, SupportUSFlexibleEmailFormObjectsTemplate,
  extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
  hasProp = {}.hasOwnProperty;

EmailFormBaseView = require("../base_view");

EmailFormUsDateTimeInputView = require("./date_time_input");

EmailFormTextLineInputView = require("../../common/views/text_line_input_view");

EmailFormTextParagraphView = require("../common/text_paragraph_view");

EmailFormTextParagraphInputView = require("../common/text_paragraph_input_view");

EmailFormNumberInputView = require("../common/number_input_view");

EmailFormFileInputView = require("../common/file_input_view");

EmailFormUSUserContactInfoView = require("./user_contact_info_view");

EmailFormPhoneNumberInputView = require("../../common/views/phone_number_input");

EmailFormCheckboxInputView = require("../common/checkbox_input_view");

EmailFormDropdownInputView = require("../common/dropdown_input_view");

EmailFormUSMerchantLocationInfoView = require("./merchant_location_info_view");

EmailFormUSUserIdentificationView = require("./user_identification_view");

EmailFormUSEmailDescriptionView = require("./email_description_view");

AlligatorView = require("../../../../../shared/frontend/views/alligator_view");

SupportStepThreeTemplate = require('../../../../step_three.html.mustache');

SupportUSFlexibleEmailFormObjectsTemplate = require('../../../../us_flexible_email_form_objects.html.mustache');

EmailFormRecaptchaView = require("../common/recaptcha_view");

EmailFormUSMainView = (function(superClass) {
  extend(EmailFormUSMainView, superClass);

  function EmailFormUSMainView() {
    return EmailFormUSMainView.__super__.constructor.apply(this, arguments);
  }

  EmailFormUSMainView.prototype.events = {
    'click .submit-button': 'onSubmitClick'
  };

  EmailFormUSMainView.prototype.initialize = function(options) {
    _.bindAll.apply(_, [this].concat(_.functions(this)));
    EmailFormBaseView.prototype.initialize.apply(this, arguments);
    this.template = SupportStepThreeTemplate;
    this.model = options.emailFormModel;
    return this.inputObjects = this.model.getEmailFormInputObjects();
  };

  EmailFormUSMainView.prototype.render = function() {
    AlligatorView.hideWidgets();
    this.renderEmailForm();
    return this;
  };

  EmailFormUSMainView.prototype.contactByEmail = function() {
    return this.renderEmailForm();
  };

  EmailFormUSMainView.prototype.renderEmailForm = function() {
    this.hideComponents();
    this.$el.html(toHtml(this.template, this.toHash(), this.I18nScope));
    this.renderInputViews(this.inputObjects, "#componentList");
    this.renderStepActions();
    this.validateEmailForm();
    return this;
  };

  EmailFormUSMainView.prototype.getViewByObjectType = function(obj) {
    var options;
    options = {
      model: obj,
      validateEmailForm: this.validateEmailForm,
      template: SupportUSFlexibleEmailFormObjectsTemplate
    };
    obj.counter = this.getEmailFormObjectCount(obj.type);
    switch (obj.type) {
      case 'user_identification':
        return new EmailFormUSUserIdentificationView(options);
      case 'merchant_location':
        options.model = _.extend(obj, {
          numberOfRedemptionLocations: this.model.numberOfRedemptionLocationsAvailable()
        });
        return new EmailFormUSMerchantLocationInfoView(options);
      case 'user_contact_info':
        return new EmailFormUSUserContactInfoView(options);
      case 'description':
        return new EmailFormUSEmailDescriptionView(options);
      case 'text_field_line':
        return new EmailFormTextLineInputView(options);
      case 'phone_number':
        return new EmailFormPhoneNumberInputView(options);
      case 'date_time':
        return new EmailFormUsDateTimeInputView(options);
      case 'calendar_with_hour_slot':
        return new EmailFormUsDateTimeInputView(options);
      case 'text_field_paragraph':
        return new EmailFormTextParagraphInputView(options);
      case 'text_paragraph':
        return new EmailFormTextParagraphView(options);
      case 'number':
        return new EmailFormNumberInputView(options);
      case 'attachment':
        return new EmailFormFileInputView(options);
      case 'checkbox':
        return new EmailFormCheckboxInputView(options);
      case 'dropdown':
        return new EmailFormDropdownInputView(options);
      case 'calendar_date':
        return new EmailFormUsDateTimeInputView(options);
      case 'recaptcha':
        return new EmailFormRecaptchaView(options);
    }
  };

  EmailFormUSMainView.prototype.getEmailFormObjectCount = function(objectType) {
    if (this.model.emailFormObjectsCount[objectType] != null) {
      return ++this.model.emailFormObjectsCount[objectType];
    }
  };

  EmailFormUSMainView.prototype.toHash = function() {
    var hash, mode, ref, ref1;
    if (((ref = window.liveChatInfo) != null ? (ref1 = ref.mode) != null ? ref1.step_three : void 0 : void 0) != null) {
      mode = window.liveChatInfo.mode.step_three;
    }
    return hash = {
      reason: this.getIssueReason(),
      is_order: Groupon.Support.currentOrder != null,
      show_reason: !this.model.isDummyCategory,
      merchant_name: getDealMerchantName(),
      faqInsteadHelpWizard: window.faqInsteadHelpWizard,
      show_all_fields_required: !this.model.isFTRDropdownCombinationSlected()
    };
  };

  EmailFormUSMainView.prototype.getFormData = function() {
    var data;
    data = EmailFormBaseView.prototype.getFormData.apply(this, arguments);
    data.flexible_form = window.evaluate(typeof experiments !== "undefined" && experiments !== null ? experiments.flexStepThreeForUS : void 0) ? experiments.flexStepThreeForUS : false;
    data.NLPSearchQuery = Groupon.Support.ContentModel.getSearchInputIssue();
    return data;
  };

  EmailFormUSMainView.prototype.getChatParams = function() {
    var params;
    return params = {
      issue: this.getIssueReason()
    };
  };

  EmailFormUSMainView.prototype.getIssueReason = function() {
    return Groupon.Support.ContentModel.getSearchInputIssue() || this.model.reasonText;
  };

  EmailFormUSMainView.prototype.remove = function() {
    $('.xdsoft_datetimepicker').remove();
    return EmailFormBaseView.prototype.remove.call(this);
  };

  EmailFormUSMainView.prototype.close = function() {};

  EmailFormUSMainView.prototype.isPhonePreferredChannel = function() {
    return false;
  };

  return EmailFormUSMainView;

})(EmailFormBaseView);

module.exports = EmailFormUSMainView;

//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9VUy9tYWluX3ZpZXcuY29mZmVlIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiL3Zhci9ncm91cG9uL2hvbWUvcm11cnVnYW4vbmFwaXN0cmFuby9idWlsZC8xNTAxNzgyMDE2MzA2LTU5NDM1L3Byb2R1Y3Rpb24tMjAxNy4wOC4wM18xNy4zNi9zdXBwb3J0X2FwcC9tb2R1bGVzL3N1cHBvcnQvZnJvbnRlbmQvdmlld3MvZW1haWxfZm9ybS9VUy9tYWluX3ZpZXcuY29mZmVlIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLElBQUEsMmhCQUFBO0VBQUE7OztBQUFBLGlCQUFBLEdBQW9CLE9BQUEsQ0FBUSxjQUFSOztBQUNwQiw0QkFBQSxHQUErQixPQUFBLENBQVEsbUJBQVI7O0FBQy9CLDBCQUFBLEdBQTZCLE9BQUEsQ0FBUSx5Q0FBUjs7QUFDN0IsMEJBQUEsR0FBNkIsT0FBQSxDQUFRLCtCQUFSOztBQUM3QiwrQkFBQSxHQUFrQyxPQUFBLENBQVEscUNBQVI7O0FBQ2xDLHdCQUFBLEdBQTJCLE9BQUEsQ0FBUSw2QkFBUjs7QUFDM0Isc0JBQUEsR0FBeUIsT0FBQSxDQUFRLDJCQUFSOztBQUN6Qiw4QkFBQSxHQUFpQyxPQUFBLENBQVEsMEJBQVI7O0FBQ2pDLDZCQUFBLEdBQWdDLE9BQUEsQ0FBUSx1Q0FBUjs7QUFDaEMsMEJBQUEsR0FBNkIsT0FBQSxDQUFRLCtCQUFSOztBQUM3QiwwQkFBQSxHQUE2QixPQUFBLENBQVEsK0JBQVI7O0FBQzdCLG1DQUFBLEdBQXNDLE9BQUEsQ0FBUSwrQkFBUjs7QUFDdEMsaUNBQUEsR0FBb0MsT0FBQSxDQUFRLDRCQUFSOztBQUNwQywrQkFBQSxHQUFrQyxPQUFBLENBQVEsMEJBQVI7O0FBQ2xDLGFBQUEsR0FBZ0IsT0FBQSxDQUFRLHFEQUFSOztBQUNoQix3QkFBQSxHQUEyQixPQUFBLENBQVEsc0NBQVI7O0FBQzNCLHlDQUFBLEdBQTRDLE9BQUEsQ0FBUSwwREFBUjs7QUFDNUMsc0JBQUEsR0FBeUIsT0FBQSxDQUFRLDBCQUFSOztBQUVuQjs7Ozs7OztnQ0FDSixNQUFBLEdBQ0U7SUFBQSxzQkFBQSxFQUF3QixlQUF4Qjs7O2dDQUVGLFVBQUEsR0FBWSxTQUFDLE9BQUQ7SUFDVixDQUFDLENBQUMsT0FBTyxDQUFDLEtBQVYsQ0FBZ0IsQ0FBaEIsRUFBbUIsQ0FBQyxJQUFELENBQU0sQ0FBQyxNQUFQLENBQWMsQ0FBQyxDQUFDLFNBQUYsQ0FBWSxJQUFaLENBQWQsQ0FBbkI7SUFDQSxpQkFBaUIsQ0FBQSxTQUFFLENBQUEsVUFBVSxDQUFDLEtBQTlCLENBQW9DLElBQXBDLEVBQTBDLFNBQTFDO0lBQ0EsSUFBQyxDQUFBLFFBQUQsR0FBWTtJQUNaLElBQUMsQ0FBQSxLQUFELEdBQVMsT0FBTyxDQUFDO1dBQ2pCLElBQUMsQ0FBQSxZQUFELEdBQWdCLElBQUMsQ0FBQSxLQUFLLENBQUMsd0JBQVAsQ0FBQTtFQUxOOztnQ0FPWixNQUFBLEdBQVEsU0FBQTtJQUNOLGFBQWEsQ0FBQyxXQUFkLENBQUE7SUFDQSxJQUFDLENBQUEsZUFBRCxDQUFBO1dBQ0E7RUFITTs7Z0NBS1IsY0FBQSxHQUFnQixTQUFBO1dBQ2QsSUFBQyxDQUFBLGVBQUQsQ0FBQTtFQURjOztnQ0FHaEIsZUFBQSxHQUFpQixTQUFBO0lBQ2YsSUFBQyxDQUFBLGNBQUQsQ0FBQTtJQUNBLElBQUMsQ0FBQSxHQUFHLENBQUMsSUFBTCxDQUFVLE1BQUEsQ0FBTyxJQUFDLENBQUEsUUFBUixFQUFrQixJQUFDLENBQUEsTUFBRCxDQUFBLENBQWxCLEVBQTZCLElBQUMsQ0FBQSxTQUE5QixDQUFWO0lBQ0EsSUFBQyxDQUFBLGdCQUFELENBQWtCLElBQUMsQ0FBQSxZQUFuQixFQUFpQyxnQkFBakM7SUFDQSxJQUFDLENBQUEsaUJBQUQsQ0FBQTtJQUNBLElBQUMsQ0FBQSxpQkFBRCxDQUFBO1dBQ0E7RUFOZTs7Z0NBUWpCLG1CQUFBLEdBQXFCLFNBQUMsR0FBRDtBQUNuQixRQUFBO0lBQUEsT0FBQSxHQUNFO01BQUEsS0FBQSxFQUFPLEdBQVA7TUFDQSxpQkFBQSxFQUFtQixJQUFDLENBQUEsaUJBRHBCO01BRUEsUUFBQSxFQUFVLHlDQUZWOztJQUlGLEdBQUcsQ0FBQyxPQUFKLEdBQWMsSUFBQyxDQUFBLHVCQUFELENBQXlCLEdBQUcsQ0FBQyxJQUE3QjtBQUNkLFlBQU8sR0FBRyxDQUFDLElBQVg7QUFBQSxXQUNPLHFCQURQO2VBQ2tDLElBQUksaUNBQUosQ0FBc0MsT0FBdEM7QUFEbEMsV0FFTyxtQkFGUDtRQUdJLE9BQU8sQ0FBQyxLQUFSLEdBQWdCLENBQUMsQ0FBQyxNQUFGLENBQVMsR0FBVCxFQUFjO1VBQUMsMkJBQUEsRUFBNkIsSUFBQyxDQUFBLEtBQUssQ0FBQyxvQ0FBUCxDQUFBLENBQTlCO1NBQWQ7ZUFDaEIsSUFBSSxtQ0FBSixDQUF3QyxPQUF4QztBQUpKLFdBS08sbUJBTFA7ZUFLZ0MsSUFBSSw4QkFBSixDQUFtQyxPQUFuQztBQUxoQyxXQU1PLGFBTlA7ZUFNZ0MsSUFBSSwrQkFBSixDQUFvQyxPQUFwQztBQU5oQyxXQU9PLGlCQVBQO2VBT2dDLElBQUksMEJBQUosQ0FBK0IsT0FBL0I7QUFQaEMsV0FRTyxjQVJQO2VBUWdDLElBQUksNkJBQUosQ0FBa0MsT0FBbEM7QUFSaEMsV0FTTyxXQVRQO2VBU2dDLElBQUksNEJBQUosQ0FBaUMsT0FBakM7QUFUaEMsV0FVTyx5QkFWUDtlQVV1QyxJQUFJLDRCQUFKLENBQWlDLE9BQWpDO0FBVnZDLFdBV08sc0JBWFA7ZUFXbUMsSUFBSSwrQkFBSixDQUFvQyxPQUFwQztBQVhuQyxXQVlPLGdCQVpQO2VBWTZCLElBQUksMEJBQUosQ0FBK0IsT0FBL0I7QUFaN0IsV0FhTyxRQWJQO2VBYXFCLElBQUksd0JBQUosQ0FBNkIsT0FBN0I7QUFickIsV0FjTyxZQWRQO2VBY3lCLElBQUksc0JBQUosQ0FBMkIsT0FBM0I7QUFkekIsV0FlTyxVQWZQO2VBZXVCLElBQUksMEJBQUosQ0FBK0IsT0FBL0I7QUFmdkIsV0FnQk8sVUFoQlA7ZUFnQnVCLElBQUksMEJBQUosQ0FBK0IsT0FBL0I7QUFoQnZCLFdBaUJPLGVBakJQO2VBaUI0QixJQUFJLDRCQUFKLENBQWlDLE9BQWpDO0FBakI1QixXQWtCTyxXQWxCUDtlQWtCd0IsSUFBSSxzQkFBSixDQUEyQixPQUEzQjtBQWxCeEI7RUFQbUI7O2dDQTJCckIsdUJBQUEsR0FBeUIsU0FBQyxVQUFEO0lBQ3ZCLElBQUcsb0RBQUg7YUFDRSxFQUFFLElBQUMsQ0FBQSxLQUFLLENBQUMscUJBQXNCLENBQUEsVUFBQSxFQURqQzs7RUFEdUI7O2dDQUl6QixNQUFBLEdBQVEsU0FBQTtBQUNOLFFBQUE7SUFBQSxJQUFHLDZHQUFIO01BQStDLElBQUEsR0FBTyxNQUFNLENBQUMsWUFBWSxDQUFDLElBQUksQ0FBQyxXQUEvRTs7V0FDQSxJQUFBLEdBQ0U7TUFBQSxNQUFBLEVBQTJCLElBQUMsQ0FBQSxjQUFELENBQUEsQ0FBM0I7TUFDQSxRQUFBLEVBQTJCLG9DQUQzQjtNQUVBLFdBQUEsRUFBMkIsQ0FBQyxJQUFDLENBQUEsS0FBSyxDQUFDLGVBRm5DO01BR0EsYUFBQSxFQUEyQixtQkFBQSxDQUFBLENBSDNCO01BSUEsb0JBQUEsRUFBMkIsTUFBTSxDQUFDLG9CQUpsQztNQUtBLHdCQUFBLEVBQTJCLENBQUMsSUFBQyxDQUFBLEtBQUssQ0FBQywrQkFBUCxDQUFBLENBTDVCOztFQUhJOztnQ0FVUixXQUFBLEdBQWEsU0FBQTtBQUNYLFFBQUE7SUFBQSxJQUFBLEdBQU8saUJBQWlCLENBQUEsU0FBRSxDQUFBLFdBQVcsQ0FBQyxLQUEvQixDQUFxQyxJQUFyQyxFQUEyQyxTQUEzQztJQUNQLElBQUksQ0FBQyxhQUFMLEdBQXdCLE1BQU0sQ0FBQyxRQUFQLDhEQUFnQixXQUFXLENBQUUsMkJBQTdCLENBQUgsR0FBeUQsV0FBVyxDQUFDLGtCQUFyRSxHQUE2RjtJQUNsSCxJQUFJLENBQUMsY0FBTCxHQUFzQixPQUFPLENBQUMsT0FBTyxDQUFDLFlBQVksQ0FBQyxtQkFBN0IsQ0FBQTtXQUN0QjtFQUpXOztnQ0FNYixhQUFBLEdBQWUsU0FBQTtBQUNiLFFBQUE7V0FBQSxNQUFBLEdBQ0U7TUFBQSxLQUFBLEVBQU8sSUFBQyxDQUFBLGNBQUQsQ0FBQSxDQUFQOztFQUZXOztnQ0FJZixjQUFBLEdBQWdCLFNBQUE7V0FDZCxPQUFPLENBQUMsT0FBTyxDQUFDLFlBQVksQ0FBQyxtQkFBN0IsQ0FBQSxDQUFBLElBQXNELElBQUMsQ0FBQSxLQUFLLENBQUM7RUFEL0M7O2dDQUdoQixNQUFBLEdBQVEsU0FBQTtJQUVOLENBQUEsQ0FBRSx3QkFBRixDQUEyQixDQUFDLE1BQTVCLENBQUE7V0FDQSxpQkFBaUIsQ0FBQSxTQUFFLENBQUEsTUFBTSxDQUFDLElBQTFCLENBQStCLElBQS9CO0VBSE07O2dDQUtSLEtBQUEsR0FBTyxTQUFBLEdBQUE7O2dDQUdQLHVCQUFBLEdBQXlCLFNBQUE7V0FDdkI7RUFEdUI7Ozs7R0F6Rk87O0FBNEZsQyxNQUFNLENBQUMsT0FBUCxHQUFpQiJ9
